import React from "react";
import BaseTable from "./BaseTable";
import General from "../../../utils/General";
import AsyncSelect from "./../../components/common/AsyncSelect";

// Subcomponents for tab contents
class InStoreTable extends React.Component {
  state = {
    selectedStore: null,
  };

  _renderToolBar() {
    return (
      <div className="t-toolbar w-300px">
        <div className="d-flex align-items-center">
          <label className="mr-3 mb-0">Company:</label>
          <div className="w-100">
            <AsyncSelect
              endpoint={window.Api.Companies}
              className={"custom-async-select__container"}
              classNamePrefix={"custom-async-select"}
              params={{}}
              isClearable={false}
              value={General.getSingleAsyncOption(this.state.selectedStore)}
              onSelected={(selectedStore) => {
                this.setState({ selectedStore });
              }}
              getOptions={(companies) => General.getAsyncOptions(companies)}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const isCompanyNameProvided = !!this.props.company?.name;
    const columns = [
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => {
          let className =
            "label label-lg font-weight-bold label-inline w-80px ";
          if (value === "Active") className += "label-light-success";
          else if (value === "Inactive") className += "label-light-danger";
          else className += "label-light-secondary";
          return <span className={className}>{value}</span>;
        },
      },
      {
        Header: "Company",
        accessor: "company",
        Cell: isCompanyNameProvided
          ? undefined
          : ({ value }) => (
              <a
                href="/companies/385"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = "/companies/385";
                }}
              >
                {value}
              </a>
            ),
      },
      { Header: "Device model", accessor: "deviceModel" },
      { Header: "Serial number", accessor: "serialNumber" },
      { Header: "Country", accessor: "country" },
      { Header: "Last transaction", accessor: "lastTransaction" },
      { Header: "Last activity", accessor: "lastActivity" },
    ];

    const sampleData = [
      {
        status: "Active",
        company: "Galway Electronics",
        deviceModel: "Pax A920",
        serialNumber: "SN-998234",
        country: "Ireland",
        lastTransaction: "2026-03-23 10:45",
        lastActivity: "Active now",
      },
      {
        status: "Active",
        company: "Cork Retailers",
        deviceModel: "Verifone V240m",
        serialNumber: "SN-772101",
        country: "Ireland",
        lastTransaction: "2026-03-22 18:20",
        lastActivity: "1 day ago",
      },
      {
        status: "Inactive",
        company: "Dublin Tech Hub",
        deviceModel: "Pax A920",
        serialNumber: "SN-882341",
        country: "Ireland",
        lastTransaction: "2026-02-15 11:30",
        lastActivity: "1 month ago",
      },
      {
        status: "Active",
        company: "Berlin Devices",
        deviceModel: "Castles S1E",
        serialNumber: "SN-112233",
        country: "Germany",
        lastTransaction: "2026-03-23 09:15",
        lastActivity: "45 min ago",
      },
      {
        status: "Active",
        company: "Paris Patisserie",
        deviceModel: "Pax A920",
        serialNumber: "SN-445566",
        country: "France",
        lastTransaction: "2026-03-22 16:50",
        lastActivity: "Yesterday",
      },
      {
        status: "Inactive",
        company: "Limerick Supplies",
        deviceModel: "Verifone V240m",
        serialNumber: "SN-990011",
        country: "Ireland",
        lastTransaction: "2026-01-10 14:00",
        lastActivity: "2 months ago",
      },
      {
        status: "Active",
        company: "Amsterdam Arts",
        deviceModel: "Pax A920",
        serialNumber: "SN-334455",
        country: "Netherlands",
        lastTransaction: "2026-03-23 12:10",
        lastActivity: "Active now",
      },
      {
        status: "Active",
        company: "Limerick Logistics",
        deviceModel: "Ingenico Move",
        serialNumber: "SN-556677",
        country: "Ireland",
        lastTransaction: "2026-03-21 17:30",
        lastActivity: "2 days ago",
      },
      {
        status: "Active",
        company: "Madrid Markets",
        deviceModel: "Pax A920",
        serialNumber: "SN-223344",
        country: "Spain",
        lastTransaction: "2026-03-23 08:00",
        lastActivity: "2 hours ago",
      },
      {
        status: "Inactive",
        company: "Waterford Wines",
        deviceModel: "Verifone V240m",
        serialNumber: "SN-667788",
        country: "Ireland",
        lastTransaction: "2026-03-01 19:45",
        lastActivity: "3 weeks ago",
      },
      {
        status: "Active",
        company: "Rome Rentals",
        deviceModel: "Pax A920",
        serialNumber: "SN-778899",
        country: "Italy",
        lastTransaction: "2026-03-23 11:55",
        lastActivity: "Just now",
      },
    ];

    const displayData = isCompanyNameProvided
      ? sampleData.map((row) => ({ ...row, company: this.props.company?.name }))
      : sampleData;

    return (
      <BaseTable
        endpoint=""
        mockData={displayData}
        columns={columns}
        showPagination={true}
        searchPlaceholder="Search device name or serial number"
        noDataMessage="No terminal found"
        showFilter={false}
        showExport={false}
        activeObjectLabel="Active"
        deletedObjectLabel="Inactive"
        showHeader={isCompanyNameProvided ? false : true}
        {...(!isCompanyNameProvided
          ? { renderToolbar: () => this._renderToolBar() }
          : {})}
      />
    );
  }
}

export default InStoreTable;
